export default __webpack_public_path__ + "static/media/deputi.17337ae1.png";